import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import './CaseStudies.css';
import { caseStudies } from '../data/site';

const industries = ['All', ...Array.from(new Set(caseStudies.map((c) => c.industry)))];
const regions = ['All', ...Array.from(new Set(caseStudies.map((c) => c.region)))];

const CaseStudies = () => {
  const [industry, setIndustry] = useState('All');
  const [region, setRegion] = useState('All');

  const filtered = useMemo(() => {
    return caseStudies.filter((c) =>
      (industry === 'All' || c.industry === industry) &&
      (region === 'All' || c.region === region)
    );
  }, [industry, region]);

  return (
    <div className="case-page page-shell">
      <section className="case-hero section-dark">
        <div className="site-container-wide">
          <span className="section-eyebrow">Case Studies</span>
          <h1>
            Production results, <span className="gradient-text serif-accent">measured in business terms.</span>
          </h1>
          <p>
            Representative engagements across financial services, healthcare, retail,
            manufacturing, energy, insurance, public sector, logistics, telecom, SaaS and pharma —
            with anonymized metrics and the operating context that matters to executive owners.
          </p>
          <div className="case-stats">
            <div><strong>12+</strong><span>representative stories</span></div>
            <div><strong>6</strong><span>core practices</span></div>
            <div><strong>3</strong><span>delivery regions</span></div>
            <div><strong>100%</strong><span>senior-led</span></div>
          </div>
        </div>
      </section>

      <section className="case-filters">
        <div className="site-container-wide case-filters-row">
          <div className="case-filter">
            <label>Industry</label>
            <div className="case-filter-options">
              {industries.map((i) => (
                <button
                  key={i}
                  className={industry === i ? 'active' : ''}
                  onClick={() => setIndustry(i)}
                  type="button"
                >{i}</button>
              ))}
            </div>
          </div>
          <div className="case-filter">
            <label>Region</label>
            <div className="case-filter-options">
              {regions.map((r) => (
                <button
                  key={r}
                  className={region === r ? 'active' : ''}
                  onClick={() => setRegion(r)}
                  type="button"
                >{r}</button>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="site-container-wide">
          <div className="case-grid">
            {filtered.map((cs) => (
              <Link to={`/case-studies/${cs.id}`} className="case-card-large professional-card" key={cs.id}>
                <img src={cs.image} alt={cs.title} />
                <div className="case-card-body">
                  <div className="case-card-meta">
                    <span className="eyebrow-tag">{cs.industry}</span>
                    <span>{cs.region}</span>
                  </div>
                  <h3>{cs.title}</h3>
                  <p>{cs.summary}</p>
                  <div className="case-card-foot">
                    <div>
                      <strong>{cs.metric}</strong>
                      <span>{cs.metricLabel}</span>
                    </div>
                    <span className="learn-more">Read story →</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="empty-state">
              <h3>No case studies match these filters.</h3>
              <p>Try a different industry or region.</p>
            </div>
          )}
        </div>
      </section>

      <section className="case-cta">
        <div className="site-container-wide professional-card">
          <h2>Ready to be the next case study?</h2>
          <p>Tell us your goal. We will tell you the path. Most discovery calls run 30 minutes.</p>
          <div className="hero-actions">
            <Link to="/request-demo" className="btn-primary-large">Book a consultation</Link>
            <Link to="/services" className="btn-outline btn-arrow">Explore services</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CaseStudies;
